// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-posts-page-layout-js": () => import("./../../../src/components/posts-page-layout.js" /* webpackChunkName: "component---src-components-posts-page-layout-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-css-selectors-js": () => import("./../../../src/pages/css-selectors.js" /* webpackChunkName: "component---src-pages-css-selectors-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-using-typescript-tsx": () => import("./../../../src/pages/using-typescript.tsx" /* webpackChunkName: "component---src-pages-using-typescript-tsx" */)
}

